import { type RestaurantToShow } from '@discover-data/stores/restaurant/model/types';
import useSession from '@discover-data/stores/hooks/session/useSession';

export default function useRegularTableConfig(
  restaurant: Pick<RestaurantToShow, 'potentialPoints' | 'regularAvailabilityConfig'>
) {
  const { potentialPoints, regularAvailabilityConfig } = restaurant;
  const [session] = useSession();
  const sessionConfig = regularAvailabilityConfig?.[session];

  const points =
    potentialPoints?.find((entry) => entry?.key === 'REGULAR_TABLE')?.value || undefined;

  return {
    points,
    sessionConfig,
  };
}
